export default "__VITE_ASSET__Q4pDro$q__"